export enum RoomType {
  LOBBY = "lobby",
  PUBLIC = "supaverse",
  CUSTOM = "custom",
  CORRIDOR = "corridor",
}

export interface IRoomData {
  name: string;
  description: string;
  password: string | null;
  autoDispose: boolean;
}
